module.exports = __webpack_public_path__ + "assets/daochu.f0188f77f0a87937122e2c5c3e42201d.png";